import { render, staticRenderFns } from "./MiniSite.vue?vue&type=template&id=08d3e3d0&lang=html&"
import script from "./MiniSite.vue?vue&type=script&lang=js&"
export * from "./MiniSite.vue?vue&type=script&lang=js&"
import style0 from "./MiniSite.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports